import React, { useEffect, useState } from 'react';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { useTranslation } from '../../../../hooks/useTranslation';
import SearchOutlinedIcon from '@material-ui/icons/SearchOutlined';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import { Button, createStyles, makeStyles, Theme } from '@material-ui/core';
import ReportOutageIcon from '../icons/ReportOutageIcon';
import mainColors from '../../../../themes/main-colors';
import {
  ResponsivePageView,
  useOutageResponsivePageTracker,
} from '../../providers/OutageResponsivePageTracker';
import { useOutageLeftPanelState } from '../../providers/OutageLeftPanelStateProvider';
import useAuth from '../../../../hooks/useAuth';
import { ReportOutage } from '../report-outage-left-panel/ReportOutage';
import { ReportOutageOtherLocation } from '../report-outage-other-location/ReportOutageOtherLocation';
import { OutageLookUpType } from '../../../../__generated__/pge-types';
import OutageHeaderSearchBar from '../OutageSearchBar/OutageSearchBar';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      padding: theme.spacing(2.5),
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    item: {
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
    },
    searchBarGrid: {
      display: 'flex',
      alignItems: 'center',
      gap: `${theme.spacing(1)}px`,
      cursor: 'pointer',
      padding: '20px 10px 20px 20px',
    },
    title: {
      fontWeight: 600,
    },
    reportOutageButton: {
      backgroundColor: mainColors.orange,
      borderColor: mainColors.orange,
      borderRadius: '40px',
      color: mainColors.white,
      fontSize: '1rem',
      paddingRight: theme.spacing(1.5),
      fontWeight: 600,
      '&:hover': {
        backgroundColor: mainColors.orange,
        borderColor: mainColors.orange,
      },
      '& svg': {
        marginRight: '8px',
      },
    },
    reportOutageButtonDisable: {
      backgroundColor: mainColors.lightGray1,
      borderColor: mainColors.lightGray1,
      borderRadius: '40px',
      color: mainColors.white,
      fontSize: '1rem',
      paddingRight: theme.spacing(1.5),
      fontWeight: 600,
      '&:hover': {
        backgroundColor: mainColors.lightGray1,
        borderColor: mainColors.lightGray1,
      },
      '& svg': {
        marginRight: '8px',
      },
    },
  }),
);
export const MapView = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  const { setPage } = useOutageResponsivePageTracker();
  const {
    panelOpen: expanded,
    setAccountNotFoundInfo,
    accountNotFoundInfo,
    setReportOutageOpen,
    outageMarkerView,
    selectedAccountForOutage,
  } = useOutageLeftPanelState();
  const { isAuthenticated } = useAuth();
  const [isSearched, setIsSearched] = useState<boolean>(false);
  const isAccountSelected = !!selectedAccountForOutage;

  useEffect(() => {
    const notificationMessageContainer: HTMLElement = document.getElementById(
      'global-notifications-banner',
    ) as HTMLElement;
    window.scrollTo({
      top:
        notificationMessageContainer.offsetHeight > 0
          ? notificationMessageContainer.offsetHeight + 96
          : 0,
      behavior: 'smooth',
    });
  }, []);

  return (
    <>
      {isSearched ? (
        <Grid className={classes.searchBarGrid}>
          <OutageHeaderSearchBar isSearchVisible={true} />
          <CloseIcon onClick={() => setIsSearched(false)} />
        </Grid>
      ) : (
        <Grid container className={classes.root}>
          <Grid
            item
            className={classes.item}
            onClick={e => {
              setPage(ResponsivePageView.Home);
            }}
          >
            <ChevronLeftIcon />
            <Typography className={classes.title}>{t('BACK')}</Typography>
          </Grid>
          <Grid item className={classes.item}>
            <Button
              className={
                isAuthenticated && !isAccountSelected
                  ? classes.reportOutageButtonDisable
                  : classes.reportOutageButton
              }
              onClick={() => {
                if (!isAuthenticated && !outageMarkerView) {
                  setReportOutageOpen(false);
                  const accountNotFound = accountNotFoundInfo;
                  setAccountNotFoundInfo({
                    ...(accountNotFound ?? {
                      lookupType: OutageLookUpType.Account,
                      lookupValue: undefined,
                    }),
                    accountNotFoundModalOpen: true,
                  });
                  return;
                } else {
                  setReportOutageOpen(true);
                }
              }}
              disabled={isAuthenticated && !isAccountSelected}
            >
              <ReportOutageIcon
                size={26}
                color={mainColors.white}
                variant="filled"
              />
              {t('REPORT_OUTAGE')}
            </Button>
          </Grid>
          <Grid item className={classes.item}>
            <SearchOutlinedIcon onClick={() => setIsSearched(true)} />
          </Grid>
        </Grid>
      )}

      <ReportOutage />
      <ReportOutageOtherLocation />
    </>
  );
};
